"use strict";

import template from "./template.html";

class ServiceEventUpdateFormController {
  constructor($scope) {
    "ngInject";

    this.$scope = $scope;

    // Internal properties for form inputs
    this._eventValue = "";
    this._estimatedResolutionTimeValue = "";
    this._actionUrl = "";

    // Watch for changes to the input models and update internal values
    this.$scope.$watch("$ctrl.eventModel", (newValue) => {
      this._eventValue = newValue;
      this._estimatedResolutionTimeValue = this._parseDateTime(
        newValue.resolution
      );
      this._actionUrl =
        "/api/entities/" +
        newValue.entity_uuid +
        "/incidents/v1/service-events/" +
        newValue.uuid;
    });
  }

  _parseDateTime(value) {
    if (!value) {
      return "";
    }

    let date;
    if (typeof value === "string") {
      date = new Date(value);
    } else if (value instanceof Date) {
      date = value;
    } else {
      return null;
    }
    return date;
  }
}

export default function () {
  return {
    scope: {
      eventModel: "<",
    },
    template: template,
    controller: ServiceEventUpdateFormController,
    controllerAs: "$ctrl",
    bindToController: true,
  };
}
